export const ADDNEW_TODO="ADDNEW_TODO";
export const GETALL_TODO = 'GETALL_TODO';
export const TOGGLE_TODO = 'TOGGLE_TODO';
export const UPDATE_TODO = 'UPDATE_TODO';
export const DELETE_TODO = 'DELETE_TODO';